export default "__VITE_ASSET__9b9c1b6b__"